import { useMemo } from "react";
import { number, object, string } from "yup";
import { REGEXP, STRING_MAX_LENGTH } from "consts/validation";
import { BooleanSwitchValue } from "consts/general";
import { BankingFormField, RecipientsPivotFormField } from "./types";

export const useBankingValidationSchema = () =>
    useMemo(() =>
        object().shape({
            [BankingFormField.BankGroup]: string()
                .max(STRING_MAX_LENGTH)
                .nullable()
                .label('Bank Group'),

            [BankingFormField.FullName]: string()
                .required()
                .label('Full Name'),

            [BankingFormField.LogoUrl]: string()
                .nullable()
                .matches(REGEXP.Asset, 'Invalid URL format')
                .max(191)
                .label('Logo URL')
        })
        , []);

export const useRecipientsPivotValidationSchema = () =>
    useMemo(() =>
        object().shape({
            [RecipientsPivotFormField.Mor]: string()
                .required()
                .label('Domain'),

            [RecipientsPivotFormField.BankId]: string()
                .required()
                .label('Bank ID'),

            [RecipientsPivotFormField.RecipientId]: string()
                .required()
                .label('Recipient ID'),

            [RecipientsPivotFormField.IsEnabled]: number()
                .oneOf([BooleanSwitchValue.Off, BooleanSwitchValue.On])
                .label('Is Enabled')
        })
        , []);
